<template>
    <v-container fluid>
        <Confirm ref="confirm" width="400"></Confirm>
        <template v-if="commission">
            <v-row>
                <!-- Commission Badge -->
                <v-col cols="12" xs="12" sm="12" md="3">
                    <v-card class="fill-height pb-3">
                        <div class="overline pl-3 pt-3">
                            <v-icon small left>mdi-account</v-icon>
                            <strong>Parceiro:&nbsp;</strong>
                            {{ commission.reseller.trade_name }}
                        </div>

                        <v-card-text class="text-center">
                            <v-col>
                                <v-list-item class="d-flex justify-center">
                                    <v-list-item-avatar size="50">
                                        <v-icon
                                            class="grey lighten-1 white--text"
                                            >mdi-calendar-month</v-icon
                                        >
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="headline font-weight-light text--darken-2 grey--text"
                                        >
                                            {{ commission.reference }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>

                            <v-col>
                                <v-chip
                                    class="ml-3"
                                    color="success"
                                    text-color="white"
                                    v-if="commission.paid"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Pago
                                </v-chip>
                                <v-chip
                                    class="ml-3"
                                    color="indigo"
                                    text-color="white"
                                    v-else-if="commission.reviewed"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Revisado
                                </v-chip>
                                <v-chip
                                    class="ml-3"
                                    color="indigo"
                                    text-color="white"
                                    v-else-if="commission.confirmed"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Aguardando revisão
                                </v-chip>
                                <v-chip
                                    class="ml-3"
                                    color="green-blue"
                                    text-color="white"
                                    v-else-if="
                                        commission.approved &&
                                            commission.is_current_month
                                    "
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Aguardando nota fiscal
                                </v-chip>
                                <v-chip
                                    color="blue-grey lighten-2"
                                    text-color="white"
                                    v-else-if="commission.is_current_month"
                                    class="ml-3"
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-clock</v-icon>
                                    </v-avatar>
                                    Pendente
                                </v-chip>
                                <v-chip
                                    color="red lighten-2"
                                    text-color="white"
                                    v-else
                                    class="ml-3"
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-close</v-icon>
                                    </v-avatar>
                                    Vencida
                                </v-chip>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- /Commission Badge -->

                <!-- Category Badge -->
                <v-col cols="12" xs="12" sm="12" md="2">
                    <v-card class="fill-height">
                        <div class="overline pl-3 pt-3">
                            <v-icon small left>mdi-medal</v-icon>
                            Categoria de comissão
                        </div>

                        <v-card-text>
                            <category-badge
                                :category="commission.category"
                                :showCommission="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- /Category Badge -->

                <v-col cols="12" xs="12" sm="12" md="3">
                    <v-card class="fill-height">
                        <div class="overline pl-3 pt-3 mb-3 text-wrap">
                            <v-icon small left>mdi-currency-usd</v-icon>
                            Valores
                        </div>

                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col class="text-center">
                                        <div class="mt-4 mb-2">
                                            <h3
                                                class="display-1 green--text font-weight-light"
                                            >
                                                {{
                                                    commission.formattedTotalValue
                                                }}
                                            </h3>
                                            <div
                                                class="blue-grey--text text--darken-2 font-weight-light mt-1 d-flex align-center justify-center"
                                            >
                                                Líquido
                                            </div>
                                            <br />
                                            Imposto:
                                            {{ commission.formattedTaxedValue }}
                                            ( {{ commission.formattedTax }})
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4">
                    <v-card class="fill-height">
                        <div class="overline pl-3 pt-3" v-if="commission.paid">
                            <v-icon small left>
                                mdi-bank
                            </v-icon>
                            Comissão Paga
                        </div>
                        <div
                            class="overline pl-3 pt-3"
                            v-else-if="commission.reviewed"
                        >
                            <v-icon small left>
                                mdi-file-document-box-check-outline
                            </v-icon>
                            Comprovante de Pagamento
                        </div>
                        <div
                            class="overline pl-3 pt-3"
                            v-else-if="commission.confirmed"
                        >
                            <v-icon small left>
                                mdi-file-document-box-check-outline
                            </v-icon>
                            Revisar nota fiscal
                        </div>
                        <div
                            class="overline pl-3 pt-3"
                            v-else-if="commission.approved"
                        >
                            <v-icon small left>
                                mdi-clock-outline
                            </v-icon>
                            Aguardando parceiro
                        </div>
                        <div class="overline pl-3 pt-3" v-else>
                            <v-icon small left>
                                mdi-cash
                            </v-icon>
                            Aprovar Valores
                        </div>
                        <v-card-text
                            v-if="
                                commission.showPaidConfirmation ||
                                    !commission.approved
                            "
                        >
                            <v-row>
                                <template
                                    v-if="commission.showPaidConfirmation"
                                >
                                    <v-col>
                                        <v-file-input
                                            label="Comprovante"
                                            v-model="payment_voucher"
                                            show-size
                                        ></v-file-input>
                                    </v-col>
                                    <v-col>
                                        <v-checkbox
                                            label="Pago"
                                            color="green"
                                            :value="true"
                                            v-model="paid"
                                        ></v-checkbox>
                                    </v-col>
                                </template>
                                <v-col v-else-if="!commission.approved_at">
                                    <v-checkbox
                                        label="Aprovado"
                                        color="indigo"
                                        :value="true"
                                        v-model="approved"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="12" class="text-right">
                                    <v-btn
                                        color="success"
                                        :loading="loadingSave"
                                        @click="save"
                                    >
                                        <v-icon left small>
                                            mdi-check
                                        </v-icon>
                                        {{ $t('form.actions.save') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text
                            v-if="
                                commission.approved &&
                                    !commission.confirmed &&
                                    commission.is_current_month
                            "
                        >
                            <v-row>
                                <v-col>
                                    Aguardando a aprovação e envio de nota
                                    fiscal pelo parceiro.
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text
                            v-if="commission.approved && !commission.confirmed"
                        >
                            <v-row>
                                <v-col>
                                    NF da comissão não emitida. Os valores foram
                                    transferidos para o mês seguinte.
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text
                            v-if="commission.confirmed && !commission.reviewed"
                        >
                            <v-col>
                                <v-row>
                                    <v-btn
                                        small
                                        outlined
                                        color="indigo"
                                        @click="downloadItem('invoice')"
                                    >
                                        <v-icon small left>
                                            mdi-file-code-outline
                                        </v-icon>
                                        Nota fiscal
                                    </v-btn>
                                </v-row>
                                <v-row>
                                    <v-textarea
                                        :label="'Motivo de recusa'"
                                        v-model="reprovedDetails"
                                    ></v-textarea>
                                </v-row>
                                <v-row>
                                    <v-btn
                                        color="success"
                                        :loading="loadingSave"
                                        @click="reviewApprove"
                                    >
                                        <v-icon left small>
                                            mdi-check
                                        </v-icon>
                                        Aprovar
                                    </v-btn>
                                    <v-btn
                                        color="error"
                                        :loading="loadingSave"
                                        @click="reviewReprove"
                                    >
                                        <v-icon left small>
                                            mdi-alert
                                        </v-icon>
                                        Reprovar
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-card-text>
                        <v-card-text v-if="commission.paid">
                            <v-row>
                                <v-col>
                                    Comissão paga e comprovante enviado para o
                                    parceiro.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        small
                                        outlined
                                        color="indigo"
                                        @click="downloadItem('invoice')"
                                    >
                                        <v-icon small left>
                                            mdi-file-code-outline
                                        </v-icon>
                                        Nota fiscal
                                    </v-btn>
                                </v-col>
                                <v-col v-if="commission.payment_voucher">
                                    <v-btn
                                        small
                                        outlined
                                        color="light-green darken-2"
                                        @click="downloadItem('payment-voucher')"
                                    >
                                        <v-icon small left>
                                            mdi-file-document-box-check-outline
                                        </v-icon>
                                        Comprovante de Pagamento
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <PeriodIndex :items="commission.commissionPeriods" />
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                    <ActivationIndex
                        :items="commission.commissionActivations"
                    />
                </v-col>
            </v-row>

            <!-- <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <v-card>
                        <v-card-title>Comissões</v-card-title>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Cliente</th>
                                        <th class="text-left">Plano</th>
                                        <th class="text-left">Valor</th>
                                        <th class="text-left">Comissão</th>
                                        <th class="text-left">Pago em</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in commission.itemsCommission"
                                        :key="item.id"
                                    >
                                        <td>{{ item.customer.trade_name }}</td>
                                        <td>{{ item.reference }}</td>
                                        <td>
                                            {{ item.formattedBaseValue }}
                                        </td>
                                        <td>{{ item.formattedValue }}</td>
                                        <td>{{ item.formattedPaidAt }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <strong>Total</strong>
                                        </td>
                                        <td>
                                            <strong>{{
                                                $n(
                                                    commission.totalValueCommission,
                                                    'currency',
                                                )
                                            }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                    <v-card>
                        <v-card-title>Ativações</v-card-title>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Cliente</th>
                                        <th class="text-left">
                                            Produto/Modulo
                                        </th>
                                        <th class="text-left">Parcela</th>
                                        <th class="text-left">Comissão</th>
                                        <th class="text-left">Pago em</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in commission.itemsActivation"
                                        :key="item.id"
                                    >
                                        <td>{{ item.customer.trade_name }}</td>
                                        <td>{{ item.reference }}</td>
                                        <td>
                                            {{ item.current_installment }} /
                                            {{ item.activation_installments }}
                                        </td>
                                        <td>
                                            {{ $n(item.value, 'currency') }}
                                        </td>
                                        <td>{{ item.formattedPaidAt }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <strong>Total</strong>
                                        </td>
                                        <td>
                                            <strong>{{
                                                $n(
                                                    commission.totalValueActivation,
                                                    'currency',
                                                )
                                            }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row> -->
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import ActivationIndex from '@/shared/components/commission/ActivationIndex'
import CategoryBadge from '@/shared/components/CategoryBadge'
import Commission from '@/models/Commission'
import PeriodIndex from '@/shared/components/commission/PeriodIndex'
import Confirm from '@/shared/components/Confirm'

export default {
    props: ['id'],

    data: () => {
        return {
            commission: null,
            loadingSave: false,
            paid: false,
            approved: false,
            reviewed: false,
            reproved: false,
            reprovedDetails: '',
            payment_voucher: null,
        }
    },

    components: {
        ActivationIndex,
        CategoryBadge,
        PeriodIndex,
        Confirm,
    },

    methods: {
        async getCommission() {
            this.commission = await this.model.find(this.id)
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        reviewApprove() {
            this.reviewed = true
            this.save()
        },

        reviewReprove() {
            if (!this.reprovedDetails) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    'É necessário informar o motivo',
                )
                return
            }
            this.reproved = true
            this.save()
        },

        async save() {
            let confirm = await this.$refs.confirm.open(
                'Confirmar ação',
                'Tem certeza que deseja atualizar o status da comissão?',
            )

            if (!confirm) {
                return
            }

            this.loadingSave = true

            let clone = this.commission.clone()
            clone.approved = this.approved
            clone.paid = this.paid
            clone.reviewed = this.reviewed
            clone.reproved = this.reproved
            clone.reproved_details = this.reprovedDetails

            if (this.payment_voucher) {
                clone.payment_voucher = await this.toBase64(
                    this.payment_voucher,
                )
            }

            let res

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loadingSave = false
            }

            if (!res) return

            this.$bus.$emit('notify', 'success', 'Comissão salva com sucesso')

            this.$router.push({
                name: 'commissions',
            })
        },

        async downloadItem(type) {
            let res = await this.$http.get(
                `commissions/${this.commission.id}/${type}`,
                {
                    responseType: 'blob',
                },
            )

            if (!res) return

            let name =
                type == 'invoice'
                    ? this.commission.invoice
                    : this.commission.payment_voucher

            const url = window.URL.createObjectURL(res.data)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', name)
            document.body.appendChild(link)
            link.click()
        },
    },

    computed: {
        model() {
            return new Commission()
        },
    },

    created() {
        this.getCommission()
    },
}
</script>

<style></style>
